import { styleConstants } from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import RadioButton from 'src/components/RadioButton/RadioButton'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ConnectionOptionProps {
  className?: string
  isCheckbox?: boolean
  onClick?: () => void
  isSelected: boolean
}

const ConnectionOption: React.FC<
  React.PropsWithChildren<ConnectionOptionProps>
> = (props): React.ReactElement => {
  const translate = useTranslate()
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        align-items: center;
        padding: 24px 20px;
        background-color: ${styleConstants.colors.gray_lightest};

        &:nth-child(n + 2) {
          border-top: 1px solid ${styleConstants.colors.gray_light};
        }
      `}
    >
      {props.isCheckbox && (
        <Checkbox
          onChange={props.onClick}
          checked={props.isSelected}
          css={css`
            margin-right: 20px;
          `}
          aria-label={translate('Connection option')}
        />
      )}
      {!props.isCheckbox && (
        <RadioButton
          onClick={props.onClick}
          isSelected={props.isSelected}
          css={css`
            margin-right: 20px;
          `}
        />
      )}
      {props.children}
    </div>
  )
}

export default ConnectionOption
